import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { HomePage } from '../pages/home/home';
import { DoctorPage } from '../pages/doctor/doctor';
import { NursePage } from '../pages/nurse/nurse';
import { ListPage } from '../pages/list/list';
import { ApiUserProvider } from '../providers/api-user/api-user';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any ;

  pages: Array<{title: string, component: any}>;
  
  constructor(public platform: Platform, public statusBar: StatusBar,public apiUserProvider:ApiUserProvider
    ,public storage: Storage, public splashScreen: SplashScreen) {
   
    
    this.storage.get('name')
    .then(data => {
    if( data)
    { 
      this.apiUserProvider.UName=data;
      this.storage.get('ISDoctor')
    .then(data2 => {    
      this.apiUserProvider.ISDoctor=true;
    
      this.storage.get('USerial')
    .then(data3 => {  this.apiUserProvider.USerial=data3; });

    this.storage.get('UFullName')
    .then(data4 => {  this.apiUserProvider.UFullName=data4; });
      //this.UName = this.PosProvider.UName;this.apiUserProvider.UFullName
       if(data2)
      this.rootPage = DoctorPage; 
      else
      this.rootPage =NursePage; 
    });
      //this.navCtrl.setRoot(ListPage );    
    }
    else
    {
      this.rootPage =HomePage; 
      //this.rootPage = HomePage;
      //this.navCtrl.setRoot(HomePage );    
    }
  });
  this.initializeApp();
    // used for an example of ngFor and navigation
    this.pages = [
      //{ title: 'الصفحة الرئيسية', component: HomePage },
      //{ title: 'List', component: ListPage },
      { title: 'تسجيل خروج', component: HomePage }
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
    if( page.title == 'تسجيل خروج')
    {
     this.ClearLogOut('name');
    }
   }
   ClearLogOut(word){
     //this.storage.clear();
     
         this.storage.ready().then(
         () => {
           this.storage.remove(word);
           this.storage.remove('ISDoctor');
           this.storage.remove('USerial');
         });
       
   }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts